"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "getBegin", {
  enumerable: true,
  get: function get() {
    return _dates.getBegin;
  }
});
Object.defineProperty(exports, "getEnd", {
  enumerable: true,
  get: function get() {
    return _dates.getEnd;
  }
});

var _dates = require("react-calendar/dist/shared/dates");